import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/notifications/notificationQueryKeys.ts
var t = e("notifications", {
	list: () => ["list"],
	unreadCount: () => ["unread-count"],
	settings: () => ["settings"],
	preferenceGroups: () => ["preference-groups"]
});
//#endregion
export { t as notificationQueryKeys };
